import { ActionButton, UnprotectedRouteResponsiveCard } from "@eisox/design-system";
import { ArrowRightIcon } from "@eisox/icons";
import { useMutation } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

import { accountApi } from "~/api";
import { loadInvalidTokenContext } from "~/features/account";
import { m } from "~/paraglide/messages";

export const Route = createFileRoute("/expired-token")({
  validateSearch: search => ({ token: (search.token as string) || "" }),
  loaderDeps: ({ search: { token } }) => ({ token }),
  loader: ({ context: { queryClient }, deps: { token } }) => loadInvalidTokenContext(queryClient, token),
  component: RouteComponent,
});

function RouteComponent() {
  const { type, email } = Route.useLoaderData();
  const navigate = Route.useNavigate();

  const { mutate: generateNewLink } = useMutation({
    meta: { toast: { success: m.account_email_sent() } },
    mutationFn: () => accountApi.requestPasswordReset(email),
    onSuccess: async () => {
      await navigate({ to: "/sign-in", search: { redirect: "" } });
    },
  });

  return (
    <UnprotectedRouteResponsiveCard version={import.meta.env.VITE_VERSION}>
      <div className="flex flex-col items-center gap-y-[40px]" data-testid="ExpiredToken">
        <p className="max-w-[365px] text-base whitespace-pre-line text-primary-dark-blue">
          {m[`expired_token_${type}`]()}
        </p>
        <p className="font-semibold text-base text-primary-dark-blue">{email}</p>
        <ActionButton onClick={() => generateNewLink()}>
          {m.generate_new_link()}
          <ArrowRightIcon />
        </ActionButton>
      </div>
    </UnprotectedRouteResponsiveCard>
  );
}
